import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import tr from '../../../libs/tr';
import './AlertPnl.css';
import popupclose from "../../../images/public/popupclose.png";

class AlertPnl extends Component {

    constructor(props) {

        super(props);
        this.closehide = props.closehide ? props.closehide : false;
        this.textbar1 = props.textbar1 ? props.textbar1 : "Text missing!";
        this.textbar2 = props.textbar2 ? props.textbar2 : "Text missing!";
        this.textbar3 = props.textbar3 ? props.textbar3 : "Text missing!";
        this.textbtn1 = props.textbtn1 ? props.textbtn1 : "Text missing!";
        this.textbtn2 = props.textbtn2 ? props.textbtn2 : "Text missing!";
        this.option1 = props.option1 ? props.option1 : null;
        this.option2 = props.option2 ? props.option2 : null;
        this.secondbar = props.secondbar ? props.secondbar : false;
        this.thirdbar = props.thirdbar ? props.thirdbar : false;
        this.singlebtn = props.singlebtn ? props.singlebtn : false;
        this.doublebtnhor = props.doublebtnhor ? props.doublebtnhor : false;
        this.doublebtnver = props.doublebtnver ? props.doublebtnver : false;
        this.discount = props.discount ? props.discount : false;
        this.sizebtn = props.sizebtn ? props.sizebtn : "big";

        this.alertOnclick = this.alertOnclick.bind(this);

        this.state = {
            totalPrice: props.totalPrice ? props.totalPrice : "",
            btnDisable: true,
        }
    }

    alertOnclick(info) {
        this.props.callback(info);
    }

    componentWillReceiveProps(nextProps) {
        const { totalPrice } = nextProps;
        this.setState({ totalPrice });
    }

    onvoucherChanged = (event) => {
        console.log(event.target.value);
        this.setState({ vcode: event.target.value, btnDisable: event.target.value.length == 0 })
    }

    render() {
        return (
            <div>
                <div className={this.discount ? "alertPnld" : "alertPnl"}>
                    <div className="alertFrame p-3">
                        {
                            !this.closehide
                            ?
                            <div className="wrap_close">
                                <div className="alertClose">
                                    <button className="closebtn"
                                        onClick={() => this.alertOnclick({ type: "closeButton" })}>
                                        <img src={popupclose} className="img-fluid" />
                                    </button>
                                </div>
                            </div>
                            :
                            null
                        }
                        <div className="innnerFrame">
                            <div className={(this.props.secondbar && ((this.props.option1 == "attention") || (this.props.option1 == "continuecart"))) ? "alertBar1a" : (this.props.secondbar) ? "alertBar1u" : "alertBar1"}>
                                {this.textbar1}
                            </div>
                            {
                                this.secondbar ?
                                <div className={((this.props.option1) == "block" || (this.props.option1 == "retry")) ? "alertBar2b" : (this.props.option2) == "gotosite" ? "alertBar2t" : this.discount ? "alertBar2d" : (this.doublebtnhor && (this.textbar1 == " ")) ? "alertBar2e" : (this.textbar1 == " ") ? "alertBar2o" :"alertBar2"}>
                                    {this.textbar2}
                                </div> : null
                            }
                            {
                                this.thirdbar ?
                                <div className={((this.props.option1) == "block" || (this.props.option1 == "retry")) ? "alertBar2b" : (this.props.option2) == "gotosite" ? "alertBar2t" : this.discount ? "alertBar2d" : (this.doublebtnhor && (this.textbar1 == " ")) ? "alertBar2e" : (this.textbar1 == " ") ? "alertBar2o" :"alertBar2"}>
                                    {this.textbar3}
                                </div> : null
                            }
                            {
                                this.discount ?
                                <div>
                                    <div className="discountBar">
                                        <div className="discountInput">
                                            <input spellCheck={false} onChange={this.onvoucherChanged} type="text" name="name" className="discountText" maxLength="50" />
                                        </div>
                                        <button onClick={() => this.alertOnclick({ type: "apply", vcode: this.state.vcode })} className="discountBtn" >{tr.t("Apply")}</button>
                                    </div>
                                    <div className="totalAmount">
                                        {tr.t("Total")}&#160;&#160;&#160;<strong className="amountText">{this.state.totalPrice}</strong>
                                    </div>
                                </div> : null
                            }
                            {   this.singlebtn ?
                                <button className={(this.props.sizebtn) == "small" ? "alertbtn1s" : (this.props.sizebtn) == "medium" ? "alertbtn1m" : "alertbtn1b"} onClick={() => this.alertOnclick({ type: "actionButton", option1: this.option1 })}>{this.textbtn1}
                                </button> : null
                            }
                            {   
                                this.doublebtnhor ?
                                <div>
                                    <button className="alertbtnhor1" onClick={() => this.alertOnclick({ type: "actionButton", option1: this.option1 })}>{this.textbtn1}</button>
                                    <button className="alertbtnhor2" onClick={() => this.alertOnclick({ type: "actionButton", option2: this.option2 })}>{this.textbtn2}</button>
                                </div> : null
                            }
                            {
                                !this.discount && this.doublebtnver ?
                                <div className="wrap_btns">
                                    <button className={this.discount ? "alertbtnver1d" : "alertbtnver1"} onClick={() => this.alertOnclick({ type: "actionButton", option1: this.option1 })}>{this.textbtn1}</button>
                                    <button className={this.discount ? "alertbtnver2d" : "alertbtnver2"} onClick={() => this.alertOnclick({ type: "actionButton", option2: this.option2 })}>{this.textbtn2}</button>
                                </div> : null
                            }
                            {   
                                this.discount && this.doublebtnver ?
                                <div className="wrap_btns">
                                    <button disabled={this.state.btnDisable} className={this.discount ? "alertbtnver1d" : "alertbtnver1"} onClick={() => this.alertOnclick({ type: "purchase", vcode: '' })}>{this.textbtn1}</button>
                                    <button className={this.discount ? "alertbtnver2d" : "alertbtnver2"} onClick={() => this.alertOnclick({ type: "purchase", vcode: this.state.vcode })}>{this.textbtn2}</button>
                                </div> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AlertPnl;



// WEBPACK FOOTER //
// ./src/assets/components/panel/AlertPnl.js